import { NavItem } from '@myhrbox/myhrbox-frontend-core';
import { Stack } from '@mui/material';
import ROUTES from 'constants/routes';
import { useTranslation } from 'react-i18next';

interface INavigationProps {
  isMobile: boolean;
  toggleMenu: () => void;
}

const Navigation = ({ isMobile, toggleMenu }: INavigationProps) => {
  const { t } = useTranslation();
  const onNavItemClick = isMobile ? toggleMenu : undefined;

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      spacing={2}
      sx={{ width: { xs: '100%', md: 'auto' } }}>
      <NavItem link={ROUTES.ASSESSMENT} onClick={onNavItemClick} title={t('header.assessments')} />
      <NavItem link={ROUTES.ACCOUNT} onClick={onNavItemClick} title={t('header.user')} />
    </Stack>
  );
};

export default Navigation;
